/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, FlexContainer } from "@nordcloud/gnui";
import {
  Exact,
  Maybe,
  Provider,
  ResourceFilter,
  SubmitSearchJobMutation,
} from "~/generated/graphql";
import { AttachToEnv } from "~/views/estate/AttachToEnv";
import { getResources } from "../../EstateDetailsPage/utils";

type Props = {
  nordcloudId: string;
  provider: Provider;
  assignments: {
    appCount: number;
    envCount: number;
  };
  // TODO: refactor to apollo client cache update
  refetch: (
    variables?:
      | Partial<
          Exact<{
            page: number;
            limit: number;
            filter?: Maybe<ResourceFilter>;
            query?: Maybe<string>;
          }>
        >
      | undefined
  ) => Promise<SubmitSearchJobMutation | undefined>;
};

export function ActionsCell({
  nordcloudId,
  provider,
  assignments,
  refetch,
}: Props) {
  const [showAttachmentSidebar, setShowAttachmentSidebar] =
    React.useState(false);

  if (assignments) {
    return null;
  }

  return (
    <FlexContainer>
      <Button
        type="button"
        severity="low"
        size="md"
        icon="link"
        onClick={() => setShowAttachmentSidebar(true)}
      />
      <AttachToEnv
        resources={getResources(nordcloudId, provider)}
        refresh={refetch}
        isOpen={showAttachmentSidebar}
        onClose={() => setShowAttachmentSidebar(false)}
      />
    </FlexContainer>
  );
}
